/* eslint-disable no-undef */

export const env = getEnvConfig();

export const functions = {
  autoCal: {},
  validate: {},
  calculate: {},
};

const configs = {
  env,
  theme: {},
  functions,
};

export default configs;
